<div class="container-fluid">

    <app-head></app-head>

    <div class="row">
        <table>
            <tr>
                <td style="height: 12vh;">
                </td>
            </tr>
            <tr>
                <td>
                </td>
            </tr>
        </table>
    </div>

    <div class="row">
        <table>
            <tr>
                <td>
                </td>
            </tr>
            <tr>
                <td>
                </td>
            </tr>
        </table>
    </div>

    <div class="row">
        <div class="col w-100">
            <br>
            <div class="container-fluid">
                <nav class="breadcrumb bg-white">
                    <a class="breadcrumb-item" href="#">首頁</a>
                    <a class="breadcrumb-item">學潛水</a>
                    <a class="breadcrumb-item">專業教練之路</a>
                </nav>
            </div>
            <br>
        </div>
    </div>

    <!-- https://mdbootstrap.com/docs/angular/layout/grid-usage/ -->
    <!-- https://mdbootstrap.com/docs/angular/layout/grid-examples/ -->
    <div class="row">
        <div class="col-xl">
        </div>
        <div class="col-xl-10">

            <table style="table-layout: fixed;">
                <tr>
                    <td><img src="../../../../assets/Image/Data/dive_pro.jpg" style="float: left; margin: 15px"></td>
                    <td class="fs-6">
                        從人們開始對於探索海洋產生興趣開始，這瑰麗的海底世界就一直蒙上神秘的面紗遲遲不肯卸下。直到現在水肺潛水訓練以及潛水裝備的發展，
                        人人都有機會能夠遨遊這片壯麗的大海了。這也使得人們對於潛水的需求日益增加，人人都想要一窺這片大海並且將這美好的經驗分享給大家。
                        <br>
                        <br>
                        對SSI 而言，我們最重要的課題就是培養出能夠教導新潛水員的教練 － SSI 開放水域潛水教練。而激發與培養初學者們對於潛水的渴望與能力就是SSI 開放水域潛水教練的核心價值。
                        <br>
                        <br>
                        SSI 教練培訓課程的目標旨在幫助SSI 潛水中心的發展、增進整個產業的知識並且透過現有的理論以及實際的訓練來加強教練們的教學技巧。
                        這就是能夠讓我們的學員達到「最極緻的潛水體驗」的主要方法！
                        <br>
                        <br>
                        SSI 教練培訓課程會提供你一個獨特的訓練課程。在你正式成為教練之前，你會在這個課程中面臨很多挑戰以及最新的知識，
                        這一切都是為了能夠讓你在這充滿競爭的潛水業界中，保有最佳競爭力而做的努力。
                    </td>
                </tr>
            </table>
            <br>
            <br>

            <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
                <li [ngbNavItem]="1">
                    <a ngbNavLink>開放水域潛水教練OWI</a>
                    <ng-template ngbNavContent class="custom-class">
                        <!-- 開放水域潛水教練OWI 課程內容 -->
                        <div>
                            <table style="table-layout: fixed;">
                                <tr>
                                    <td><img src="../../../../assets/Image/Data/OWI.jpg"></td>
                                    <td class="fs-6">
                                        只要你是潛水主管(DCS)並且通過了教練培訓課程與評估階段後，你就是正式的SSI 開放水域潛水教練了(OWI)。成為開放水域潛水教練後
                                        可以進行以下教學並給予認證：室內潛水員、水肺潛水員、青少年開放水域潛水員、開放水域潛水員、進階探索潛水員、水肺技巧複習、體驗潛水、
                                        高氧潛水以及壓力與救援潛水。
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <!-- 開放水域潛水教練OWI 課程規劃 -->
                        <div>
                            <table border="0" width="80%">
                                <tr>
                                    <td class="fs-6" nowrap>學科：</td>
                                    <td class="fs-6">12堂教練基礎課程與OWD試講試講、3項專長教練培訓 ( 高氧、完美浮力、壓力與救援 )。</td>
                                </tr>
                                <tr>
                                    <td class="fs-6" nowrap>術科：</td>
                                    <td class="fs-6">水性與體能評估、OWD與專長課程之學科、泳池、海洋結訓之觀察與試教評估。</td>
                                </tr>
                            </table>
                        </div>
                        <!-- 開放水域潛水教練OWI 開課日期 -->
                        <div>
                            <br>
                            <p class="fs-6">每年冬季開班, 共計13天。</p>
                            <br>
                        </div>
                        <!-- 開放水域潛水教練OWI 超值學費 -->
                        <div>
                            <ul class="fs-6" style="color: green;">
                                <li>學費 40,000元。(不含教練考試之相關費用)。</li>
                                <li>費用包含：教材、證照申請、泳池費用、教練費。</li>
                                <li>費用不含：交通、餐點、教練評估測驗費用(2017年價格為18,000)。</li>
                                <br>
                                <li>潛水長套裝：DG+SOD(DM)，原價 45,000 元，優惠套裝價 39,000 元</li>
                                <li>助理教練套奘：DG+SOD(DM)+AI 原價 93,000 元，優惠套裝價 65,000 元</li>
                                <li>教練套奘：DG+SOD(DM)+AI+ITC 原價 120,000 元，優惠套裝價 100,000 元(不含IE教練考試)</li>
                            </ul>
                        </div>
                        <!-- 開放水域潛水教練OWI 報名方式 -->
                        <div>
                            <br>
                            <app-paymentmethod></app-paymentmethod>
                            <br>
                        </div>
                        <!-- 開放水域潛水教練OWI 學前須知 -->
                        <div>
                            <ol class="fs-6">
                                <li>本課程為教練培訓課程Instructor Training Course (ITC)。</li>
                                <li>完成此課程可取得助教執照，並擁有教練評估的資格。</li>
                                <li>欲參與教練評估Instructor Eevaluate (IE) 需額外負擔教練評估費用。</li>
                                <li>
                                    iDiving採保證班的教學方式，如果學員延訓不另外加收訓練費或裝備使用費。所有課程須於2<br>
                                    個月內完成 (9月後報名隔年5月前完成)。約定日期之更改須在15天前告知。15天內更動<br>
                                    或未告知而曠課，補課需額外負擔1000元，身體不適，出示醫院掛號收據者不收。
                                </li>
                                <li>
                                    若學員自行放棄課程，本訓練中心將不予退費(包含訂金)；但因身體不適且經醫生證明不宜從事潛水活動者，<br>
                                    繳交之訓練費用在扣除已支付的成本後，餘額將全數退還。<br>
                                </li>
                                <li>學員在 iDiving 購買潛水器材享有學員優惠價。</li>
                                <li>課程之訓練費用、器材之購買費用與 2 吋大頭照一張，請於術科前繳齊。</li>
                                <li>海洋實習地點為東北角或各移地結訓地，往返之交通請自行處理。</li>
                                <li>
                                    學員結訓後，訓練中心將於兩週內完成 SSI 國際數位潛水證照申請。<br>
                                    （如有急需請先告知，本中心可於課程完成後的兩個工作天內完成申請）
                                </li>
                            </ol>
                        </div>
                    </ng-template>
                </li>
                <li [ngbNavItem]="2">
                    <a ngbNavLink>專長教練SPI</a>
                    <ng-template ngbNavContent>
                        <!-- 潛水長 DM 課程內容 -->
                        <div>
                            <table style="table-layout: fixed;">
                                <tr>
                                    <td><img src="../../../../assets/Image/Data/SPI.jpg"></td>
                                    <td class="fs-6">
                                        當你成為開放水域潛水教練後(OWI)，還可以繼續向上提升為專長教練！如果你想教導各項SSI 專長科目，必須參加專長教練研討會、
                                        協同教學或是透過投遞專業資歷的方式進行。這些專長課程包括：高海拔潛水、船潛、洞穴潛水、深潛、水中數位攝影、乾式防寒衣潛水、
                                        器材維修、冰下潛水、獨立潛水、水中導航、夜潛／低能見度潛水、完美浮力、潛水學科專長、搜索與尋回、鯊魚觀賞潛水、潮汐與水流、
                                        沉船潛水還有更多專業課程…。
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <!-- 潛水長 DM 課程規劃 -->
                        <div>
                            <table border="0" width="80%">
                                <tr>
                                    <td class="fs-6" nowrap>學科：</td>
                                    <td class="fs-6">學科一堂。</td>
                                </tr>
                                <tr>
                                    <td class="fs-6" nowrap>術科：</td>
                                    <td class="fs-6">1~2天泳池與海洋實習課程。</td>
                                </tr>
                            </table>
                        </div>
                        <!-- 潛水長 DM 開課日期 -->
                        <div>
                            <br>
                            <p class="fs-6">開課日期彈性調整。</p>
                            <br>
                        </div>
                        <!-- 潛水長 DM 超值學費 -->
                        <div>
                            <ul class="fs-6" style="color: green;">
                                <li>一項專長教練培訓課程 10,000元。</li>
                                <li>一次報名5項專長教練培訓課程30,000元。</li>
                                <li>費用包含：線上教材、國際數位證照申請、教練費。</li>
                            </ul>
                        </div>
                        <!-- 開放水域潛水教練OWI 報名方式 -->
                        <div>
                            <br>
                            <app-paymentmethod></app-paymentmethod>
                            <br>
                        </div>
                        <!-- 開放水域潛水教練OWI 學前須知 -->
                        <div>
                            <ol class="fs-6">
                                <li>
                                    iDiving採保證班的教學方式，如果學員延訓不另外加收訓練費或裝備使用費。所有課程須於2<br>
                                    個月內完成 (9月後報名隔年5月前完成)。約定日期之更改須在15天前告知。15天內更動<br>
                                    或未告知而曠課，補課需額外負擔1000元，身體不適，出示醫院掛號收據者不收。
                                </li>
                                <li>
                                    若學員自行放棄課程，本訓練中心將不予退費(包含訂金)；但因身體不適且經醫生證明不宜從事潛水活動者，<br>
                                    繳交之訓練費用在扣除已支付的成本後，餘額將全數退還。<br>
                                </li>
                                <li>學員在 iDiving 購買潛水器材享有學員優惠價。</li>
                                <li>課程之訓練費用、器材之購買費用與 2 吋大頭照一張，請於術科前繳齊。</li>
                                <li>海洋實習地點為東北角或各移地結訓地，往返之交通請自行處理。</li>
                                <li>
                                    學員結訓後，訓練中心將於兩週內完成 SSI 國際數位潛水證照申請。<br>
                                    （如有急需請先告知，本中心可於課程完成後的兩個工作天內完成申請）
                                </li>
                            </ol>
                        </div>
                    </ng-template>
                </li>
                <li [ngbNavItem]="3">
                    <a ngbNavLink>進階教練AOWI</a>
                    <ng-template ngbNavContent>
                        <!-- 進階教練AOWI 課程內容 -->
                        <div>
                            <table style="table-layout: fixed;">
                                <tr>
                                    <td><img src="../../../../assets/Image/Data/DCS.jpg"></td>
                                    <td class="fs-6">
                                        只要你達成4項專長認證而且核發超過15張專業課程的認證，你就會自動的擢升為進階開放水域潛水教練了(AOWI)。在發證後，進階潛水教練將可以教學、
                                        監督、核發下列課程：進階開放水域潛水課程、青少年進階開放水域潛水課程、浮潛教練培訓課程以及任何您已具備教學資格的專業課程。
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </ng-template>
                </li>
                <li [ngbNavItem]="4">
                    <a ngbNavLink>潛水長教練DMI</a>
                    <ng-template ngbNavContent>
                        <!-- 助理教練 AI 課程內容 -->
                        <div>
                            <table style="table-layout: fixed;">
                                <tr>
                                    <td><img src="../../../../assets/Image/Data/DCS.jpg"></td>
                                    <td class="fs-6">
                                        當您取得進階開放水域教練後，潛水經驗超過１５０次，取得ＤＧ＋ＳＯＤ的教材，並完成ＤＭＩ線上考試，即可取得潛水長教練資格。在發證後，
                                        潛水長教練將可以教學、監督、核發下列課程：專業潛導、潛水學科專長、潛水長以及任何您已具備教學資格的專業課程。並可以往潛水主管專長教練
                                        （ＤＣＳＩ）邁進。
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </ng-template>
                </li>
            </ul>

            <div [ngbNavOutlet]="nav" class="mt-2"></div>

            <!-- <pre>Active: {{ active }}</pre> -->

        </div>
        <div class="col-xl">
        </div>
    </div>

    <div class="row">
        <table>
            <tr>
                <td>
                </td>
            </tr>
            <tr>
                <td>
                </td>
            </tr>
        </table>
    </div>

    <app-foot></app-foot>

</div>